/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
"use strict";

var $protobuf = require("protobufjs/light");
$protobuf.roots={};
var $root = ($protobuf.roots["default"] || ($protobuf.roots["default"] = new $protobuf.Root()))
.addJSON({
  model: {
    nested: {
      AppAd: {
        fields: {
          appAds: {
            rule: "repeated",
            type: "AppAdItem",
            id: 1
          }
        },
        nested: {
          AppAdItem: {
            oneofs: {
              _interval: {
                oneof: [
                  "interval"
                ]
              },
              _title: {
                oneof: [
                  "title"
                ]
              },
              _img: {
                oneof: [
                  "img"
                ]
              },
              _url: {
                oneof: [
                  "url"
                ]
              }
            },
            fields: {
              id: {
                type: "int32",
                id: 1
              },
              siteId: {
                type: "int32",
                id: 2
              },
              interval: {
                type: "int32",
                id: 3,
                options: {
                  proto3_optional: true
                }
              },
              title: {
                type: "string",
                id: 4,
                options: {
                  proto3_optional: true
                }
              },
              img: {
                type: "string",
                id: 5,
                options: {
                  proto3_optional: true
                }
              },
              url: {
                type: "string",
                id: 6,
                options: {
                  proto3_optional: true
                }
              }
            }
          }
        }
      },
      Response: {
        oneofs: {
          _error: {
            oneof: [
              "error"
            ]
          },
          _msg: {
            oneof: [
              "msg"
            ]
          },
          _data: {
            oneof: [
              "data"
            ]
          },
          _subType: {
            oneof: [
              "subType"
            ]
          },
          _sportType: {
            oneof: [
              "sportType"
            ]
          },
          _langNumber: {
            oneof: [
              "langNumber"
            ]
          },
          _matchId: {
            oneof: [
              "matchId"
            ]
          },
          _subTypeDetail: {
            oneof: [
              "subTypeDetail"
            ]
          }
        },
        fields: {
          state: {
            type: "uint32",
            id: 1
          },
          error: {
            type: "string",
            id: 2,
            options: {
              proto3_optional: true
            }
          },
          msg: {
            type: "string",
            id: 3,
            options: {
              proto3_optional: true
            }
          },
          data: {
            type: "google.protobuf.Any",
            id: 4,
            options: {
              proto3_optional: true
            }
          },
          subType: {
            type: "int32",
            id: 5,
            options: {
              proto3_optional: true
            }
          },
          sportType: {
            type: "int32",
            id: 6,
            options: {
              proto3_optional: true
            }
          },
          langNumber: {
            type: "int32",
            id: 7,
            options: {
              proto3_optional: true
            }
          },
          matchId: {
            type: "uint64",
            id: 8,
            options: {
              proto3_optional: true
            }
          },
          subTypeDetail: {
            type: "int32",
            id: 9,
            options: {
              proto3_optional: true
            }
          },
          serverTimestamp: {
            type: "uint32",
            id: 10
          }
        }
      },
      Subscribe: {
        oneofs: {
          _userToken: {
            oneof: [
              "userToken"
            ]
          },
          _matchId: {
            oneof: [
              "matchId"
            ]
          },
          _comId: {
            oneof: [
              "comId"
            ]
          }
        },
        fields: {
          type: {
            type: "int32",
            id: 1
          },
          sportType: {
            type: "int32",
            id: 2
          },
          langNumber: {
            type: "int32",
            id: 3
          },
          platform: {
            type: "int32",
            id: 4
          },
          appVersion: {
            type: "string",
            id: 5
          },
          appChannel: {
            type: "string",
            id: 6
          },
          userToken: {
            type: "string",
            id: 7,
            options: {
              proto3_optional: true
            }
          },
          matchId: {
            type: "uint64",
            id: 8,
            options: {
              proto3_optional: true
            }
          },
          scoreVersion: {
            type: "uint64",
            id: 9
          },
          comId: {
            type: "uint32",
            id: 10,
            options: {
              proto3_optional: true
            }
          }
        }
      },
      PlayerFrom: {
        fields: {
          id: {
            type: "uint32",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          },
          logo: {
            type: "string",
            id: 3
          },
          type: {
            type: "uint32",
            id: 4
          }
        }
      },
      PlayerPosition: {
        fields: {
          id: {
            type: "uint32",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          }
        }
      },
      LuckCompany: {
        fields: {
          id: {
            type: "string",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          },
          hasLive: {
            type: "uint32",
            id: 3
          }
        }
      },
      LuckCompanyList: {
        fields: {
          companies: {
            rule: "repeated",
            type: "LuckCompany",
            id: 1
          }
        }
      },
      AsianLuck: {
        fields: {
          companyId: {
            type: "string",
            id: 1
          },
          handInit: {
            type: "string",
            id: 2
          },
          homeInit: {
            type: "string",
            id: 3
          },
          awayInit: {
            type: "string",
            id: 4
          },
          hand: {
            type: "string",
            id: 5
          },
          home: {
            type: "string",
            id: 6
          },
          away: {
            type: "string",
            id: 7
          },
          result: {
            type: "uint32",
            id: 8
          },
          resultInit: {
            type: "uint32",
            id: 9
          }
        }
      },
      ThreeWayLuck: {
        fields: {
          companyId: {
            type: "string",
            id: 1
          },
          homeInit: {
            type: "string",
            id: 2
          },
          drawInit: {
            type: "string",
            id: 3
          },
          awayInit: {
            type: "string",
            id: 4
          },
          home: {
            type: "string",
            id: 5
          },
          draw: {
            type: "string",
            id: 6
          },
          away: {
            type: "string",
            id: 7
          },
          result: {
            type: "uint32",
            id: 8
          },
          resultInit: {
            type: "uint32",
            id: 9
          }
        }
      },
      TotalLuck: {
        fields: {
          companyId: {
            type: "string",
            id: 1
          },
          totalInit: {
            type: "string",
            id: 2
          },
          overInit: {
            type: "string",
            id: 3
          },
          underInit: {
            type: "string",
            id: 4
          },
          total: {
            type: "string",
            id: 5
          },
          over: {
            type: "string",
            id: 6
          },
          under: {
            type: "string",
            id: 7
          },
          result: {
            type: "uint32",
            id: 8
          },
          resultInit: {
            type: "uint32",
            id: 9
          }
        }
      },
      LuckRecord: {
        fields: {
          companyId: {
            type: "string",
            id: 1
          },
          recordType: {
            type: "uint32",
            id: 2
          },
          recordValues: {
            rule: "repeated",
            type: "string",
            id: 3
          },
          ratios: {
            rule: "repeated",
            type: "string",
            id: 4
          },
          updateTime: {
            type: "uint64",
            id: 5
          }
        }
      },
      ListPageInfo: {
        fields: {
          page: {
            type: "uint32",
            id: 1
          },
          pageSize: {
            type: "uint32",
            id: 2
          },
          pageCount: {
            type: "uint32",
            id: 3
          },
          total: {
            type: "uint32",
            id: 4
          }
        }
      },
      BaseTeam: {
        oneofs: {
          _id: {
            oneof: [
              "id"
            ]
          },
          _fullName: {
            oneof: [
              "fullName"
            ]
          },
          _shortName: {
            oneof: [
              "shortName"
            ]
          },
          _logo: {
            oneof: [
              "logo"
            ]
          }
        },
        fields: {
          id: {
            type: "uint32",
            id: 1,
            options: {
              proto3_optional: true
            }
          },
          fullName: {
            type: "string",
            id: 2,
            options: {
              proto3_optional: true
            }
          },
          shortName: {
            type: "string",
            id: 3,
            options: {
              proto3_optional: true
            }
          },
          logo: {
            type: "string",
            id: 4,
            options: {
              proto3_optional: true
            }
          }
        }
      },
      UploadImageInfo: {
        fields: {
          key: {
            type: "string",
            id: 1
          },
          url: {
            type: "string",
            id: 2
          }
        }
      },
      Intro: {
        fields: {
          content: {
            type: "string",
            id: 1
          }
        }
      },
      Special: {
        fields: {
          id: {
            type: "int32",
            id: 1
          },
          flag: {
            type: "bool",
            id: 2
          }
        }
      },
      Country: {
        fields: {
          id: {
            type: "uint32",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          }
        }
      },
      FootballMatch: {
        oneofs: {
          _note: {
            oneof: [
              "note"
            ]
          },
          _homeLive: {
            oneof: [
              "homeLive"
            ]
          },
          _awayLive: {
            oneof: [
              "awayLive"
            ]
          },
          _daySpan: {
            oneof: [
              "daySpan"
            ]
          },
          _hasLineup: {
            oneof: [
              "hasLineup"
            ]
          },
          _hasStats: {
            oneof: [
              "hasStats"
            ]
          },
          _hasEventLive: {
            oneof: [
              "hasEventLive"
            ]
          },
          _hasLuck: {
            oneof: [
              "hasLuck"
            ]
          },
          _hasPrediction: {
            oneof: [
              "hasPrediction"
            ]
          }
        },
        fields: {
          matchId: {
            type: "uint64",
            id: 1
          },
          leagueId: {
            type: "uint64",
            id: 2
          },
          startTime: {
            type: "uint64",
            id: 3
          },
          startHalfTime: {
            type: "uint64",
            id: 4
          },
          injuryTime: {
            type: "uint32",
            id: 5
          },
          note: {
            type: "string",
            id: 6,
            options: {
              proto3_optional: true
            }
          },
          homeRank: {
            type: "string",
            id: 7
          },
          awayRank: {
            type: "string",
            id: 8
          },
          homeTeam: {
            type: "FootballTeam",
            id: 9
          },
          awayTeam: {
            type: "FootballTeam",
            id: 10
          },
          homeLive: {
            type: "FootballTeamLive",
            id: 11,
            options: {
              proto3_optional: true
            }
          },
          awayLive: {
            type: "FootballTeamLive",
            id: 12,
            options: {
              proto3_optional: true
            }
          },
          neutral: {
            type: "bool",
            id: 13
          },
          state: {
            type: "uint32",
            id: 14
          },
          daySpan: {
            type: "uint32",
            id: 15,
            options: {
              proto3_optional: true
            }
          },
          hasLineup: {
            type: "int32",
            id: 16,
            options: {
              proto3_optional: true
            }
          },
          hasStats: {
            type: "bool",
            id: 17,
            options: {
              proto3_optional: true
            }
          },
          hasEventLive: {
            type: "bool",
            id: 18,
            options: {
              proto3_optional: true
            }
          },
          hasLuck: {
            type: "bool",
            id: 19,
            options: {
              proto3_optional: true
            }
          },
          hasPrediction: {
            type: "bool",
            id: 20,
            options: {
              proto3_optional: true
            }
          },
          stageId: {
            type: "int32",
            id: 21
          }
        }
      },
      FootballMatchUpdate: {
        fields: {
          matchId: {
            type: "uint64",
            id: 1
          },
          startHalfTime: {
            type: "uint64",
            id: 2
          },
          injuryTime: {
            type: "uint32",
            id: 3
          },
          note: {
            type: "string",
            id: 4
          },
          homeLive: {
            type: "FootballTeamLive",
            id: 5
          },
          awayLive: {
            type: "FootballTeamLive",
            id: 6
          },
          state: {
            type: "uint32",
            id: 7
          }
        }
      },
      FootballTeamLive: {
        oneofs: {
          _yellowCard: {
            oneof: [
              "yellowCard"
            ]
          },
          _redCard: {
            oneof: [
              "redCard"
            ]
          },
          _corner: {
            oneof: [
              "corner"
            ]
          },
          _scoreHalf: {
            oneof: [
              "scoreHalf"
            ]
          },
          _scoreOt: {
            oneof: [
              "scoreOt"
            ]
          },
          _scorePen: {
            oneof: [
              "scorePen"
            ]
          },
          _scoreRound1: {
            oneof: [
              "scoreRound1"
            ]
          },
          _scoreRound2: {
            oneof: [
              "scoreRound2"
            ]
          }
        },
        fields: {
          yellowCard: {
            type: "uint32",
            id: 1,
            options: {
              proto3_optional: true
            }
          },
          redCard: {
            type: "uint32",
            id: 2,
            options: {
              proto3_optional: true
            }
          },
          corner: {
            type: "uint32",
            id: 3,
            options: {
              proto3_optional: true
            }
          },
          scoreFull: {
            type: "uint32",
            id: 4
          },
          scoreHalf: {
            type: "uint32",
            id: 5,
            options: {
              proto3_optional: true
            }
          },
          scoreOt: {
            type: "uint32",
            id: 6,
            options: {
              proto3_optional: true
            }
          },
          scorePen: {
            type: "uint32",
            id: 7,
            options: {
              proto3_optional: true
            }
          },
          scoreRound1: {
            type: "uint32",
            id: 8,
            options: {
              proto3_optional: true
            }
          },
          scoreRound2: {
            type: "uint32",
            id: 9,
            options: {
              proto3_optional: true
            }
          }
        }
      },
      FootballLeague: {
        oneofs: {
          _country: {
            oneof: [
              "country"
            ]
          },
          _hasStanding: {
            oneof: [
              "hasStanding"
            ]
          }
        },
        fields: {
          id: {
            type: "uint64",
            id: 1
          },
          fullName: {
            type: "string",
            id: 2
          },
          shortName: {
            type: "string",
            id: 3
          },
          color: {
            type: "string",
            id: 4
          },
          grade: {
            type: "uint32",
            id: 5
          },
          hasDt: {
            type: "bool",
            id: 6
          },
          country: {
            type: "FootballLeagueCountry",
            id: 7,
            options: {
              proto3_optional: true
            }
          },
          hasStanding: {
            type: "bool",
            id: 8,
            options: {
              proto3_optional: true
            }
          }
        }
      },
      FootballLeagueCountry: {
        fields: {
          id: {
            type: "uint32",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          }
        }
      },
      FootballTeam: {
        fields: {
          id: {
            type: "uint64",
            id: 1
          },
          fullName: {
            type: "string",
            id: 2
          },
          shortName: {
            type: "string",
            id: 3
          }
        }
      },
      FootballPlayer: {
        oneofs: {
          _jerseyNumber: {
            oneof: [
              "jerseyNumber"
            ]
          },
          _age: {
            oneof: [
              "age"
            ]
          },
          _positionType: {
            oneof: [
              "positionType"
            ]
          },
          _positionName: {
            oneof: [
              "positionName"
            ]
          }
        },
        fields: {
          id: {
            type: "uint64",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          },
          englishName: {
            type: "string",
            id: 3
          },
          jerseyNumber: {
            type: "uint32",
            id: 4,
            options: {
              proto3_optional: true
            }
          },
          fromInfo: {
            rule: "repeated",
            type: "PlayerFrom",
            id: 5
          },
          age: {
            type: "uint32",
            id: 6,
            options: {
              proto3_optional: true
            }
          },
          positionType: {
            type: "uint32",
            id: 7,
            options: {
              proto3_optional: true
            }
          },
          positionName: {
            type: "string",
            id: 8,
            options: {
              proto3_optional: true
            }
          }
        }
      },
      SimpleMatch: {
        oneofs: {
          _homeLive: {
            oneof: [
              "homeLive"
            ]
          },
          _awayLive: {
            oneof: [
              "awayLive"
            ]
          }
        },
        fields: {
          matchId: {
            type: "uint64",
            id: 1
          },
          leagueId: {
            type: "uint64",
            id: 2
          },
          startTime: {
            type: "uint64",
            id: 3
          },
          startHalfTime: {
            type: "uint64",
            id: 4
          },
          homeTeam: {
            type: "BaseTeam",
            id: 5
          },
          awayTeam: {
            type: "BaseTeam",
            id: 6
          },
          homeLive: {
            type: "FootballTeamLive",
            id: 11,
            options: {
              proto3_optional: true
            }
          },
          awayLive: {
            type: "FootballTeamLive",
            id: 12,
            options: {
              proto3_optional: true
            }
          },
          state: {
            type: "uint32",
            id: 14
          }
        }
      },
      FootballStage: {
        fields: {
          id: {
            type: "int32",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          },
          isCurrent: {
            type: "bool",
            id: 3
          }
        }
      },
      FootballSeason: {
        fields: {
          seasonkey: {
            type: "string",
            id: 1
          },
          seasonValue: {
            type: "string",
            id: 2
          }
        }
      },
      FootballLeagueInfo: {
        fields: {
          league: {
            type: "FootballLeague",
            id: 1
          },
          seasonStart: {
            type: "uint64",
            id: 2
          },
          seasonEnd: {
            type: "uint64",
            id: 3
          },
          seasonList: {
            rule: "repeated",
            type: "FootballSeason",
            id: 4
          },
          isFollow: {
            type: "bool",
            id: 5
          }
        }
      },
      FootballLeagueList: {
        fields: {
          league: {
            rule: "repeated",
            type: "FootballLeague",
            id: 1
          }
        }
      },
      FootballLeagueFixture: {
        fields: {
          currentRun: {
            type: "string",
            id: 1
          },
          allRun: {
            rule: "repeated",
            type: "string",
            id: 2
          },
          match: {
            rule: "repeated",
            type: "MatchGroup",
            id: 3
          },
          followMatch: {
            keyType: "uint32",
            type: "bool",
            id: 4
          }
        },
        nested: {
          MatchGroup: {
            fields: {
              run: {
                type: "string",
                id: 1
              },
              group: {
                type: "string",
                id: 2
              },
              matchList: {
                rule: "repeated",
                type: "FootballMatch",
                id: 3
              }
            }
          }
        }
      },
      FootballLeagueStandings: {
        oneofs: {
          _leagueFormat: {
            oneof: [
              "leagueFormat"
            ]
          }
        },
        fields: {
          leagueFormat: {
            type: "string",
            id: 1,
            options: {
              proto3_optional: true
            }
          },
          grade: {
            rule: "repeated",
            type: "StandingGrade",
            id: 2
          },
          group: {
            rule: "repeated",
            type: "StandingGroup",
            id: 3
          }
        },
        nested: {
          StandingGrade: {
            fields: {
              id: {
                type: "uint32",
                id: 1
              },
              name: {
                type: "string",
                id: 2
              },
              color: {
                type: "string",
                id: 3
              }
            }
          },
          StandingGroup: {
            fields: {
              id: {
                type: "uint32",
                id: 1
              },
              name: {
                type: "string",
                id: 2
              },
              allStandings: {
                rule: "repeated",
                type: "StandingItem",
                id: 3
              },
              homeStandings: {
                rule: "repeated",
                type: "StandingItem",
                id: 4
              },
              awayStandings: {
                rule: "repeated",
                type: "StandingItem",
                id: 5
              }
            }
          },
          StandingItem: {
            fields: {
              team: {
                type: "FootballTeam",
                id: 1
              },
              gradeId: {
                type: "uint32",
                id: 2
              },
              matches: {
                type: "uint32",
                id: 3
              },
              win: {
                type: "uint32",
                id: 4
              },
              draw: {
                type: "uint32",
                id: 5
              },
              loss: {
                type: "uint32",
                id: 6
              },
              gf: {
                type: "uint32",
                id: 7
              },
              ga: {
                type: "uint32",
                id: 8
              },
              winDiff: {
                type: "int32",
                id: 9
              },
              pts: {
                type: "uint32",
                id: 10
              },
              note: {
                type: "string",
                id: 11
              },
              recentFiveResult: {
                rule: "repeated",
                type: "uint32",
                id: 12
              },
              recentFive: {
                rule: "repeated",
                type: "FootballMatch",
                id: 13
              },
              isPlaying: {
                type: "bool",
                id: 14
              }
            }
          }
        }
      },
      FootballLeagueStandingsAH: {
        fields: {
          allStandings: {
            rule: "repeated",
            type: "StandingAHItem",
            id: 1
          },
          homeStandings: {
            rule: "repeated",
            type: "StandingAHItem",
            id: 2
          },
          awayStandings: {
            rule: "repeated",
            type: "StandingAHItem",
            id: 3
          }
        },
        nested: {
          StandingAHItem: {
            fields: {
              team: {
                type: "FootballTeam",
                id: 1
              },
              matches: {
                type: "uint32",
                id: 2
              },
              luck: {
                type: "uint32",
                id: 3
              },
              upLuck: {
                type: "uint32",
                id: 4
              },
              win: {
                type: "uint32",
                id: 5
              },
              draw: {
                type: "uint32",
                id: 6
              },
              loss: {
                type: "uint32",
                id: 7
              },
              winDiff: {
                type: "int32",
                id: 8
              },
              winRate: {
                type: "string",
                id: 9
              },
              recentFiveLuck: {
                rule: "repeated",
                type: "AsianLuck",
                id: 10
              },
              recentFive: {
                rule: "repeated",
                type: "FootballMatch",
                id: 11
              }
            }
          }
        }
      },
      FootballLeagueAll: {
        fields: {
          group: {
            rule: "repeated",
            type: "Group",
            id: 1
          },
          defaultHotLeague: {
            type: "FootballLeague",
            id: 2
          }
        },
        nested: {
          GroupCountry: {
            fields: {
              id: {
                type: "int32",
                id: 1
              },
              name: {
                type: "string",
                id: 2
              },
              league: {
                rule: "repeated",
                type: "FootballLeague",
                id: 3
              }
            }
          },
          Group: {
            fields: {
              id: {
                type: "int32",
                id: 1
              },
              name: {
                type: "string",
                id: 2
              },
              country: {
                rule: "repeated",
                type: "GroupCountry",
                id: 3
              }
            }
          }
        }
      },
      FootballLeagueTeamStatisticsItem: {
        fields: {
          rank: {
            type: "int32",
            id: 1
          },
          team: {
            type: "FootballTeam",
            id: 2
          },
          preGame: {
            type: "string",
            id: 3
          },
          num: {
            type: "string",
            id: 4
          }
        }
      },
      FootballLeagueTeamStatisticsRank: {
        fields: {
          name: {
            type: "string",
            id: 1
          },
          items: {
            rule: "repeated",
            type: "FootballLeagueTeamStatisticsItem",
            id: 2
          }
        }
      },
      FootballLeagueTeamStatistics: {
        fields: {
          list: {
            rule: "repeated",
            type: "FootballLeagueTeamStatisticsRank",
            id: 1
          }
        }
      },
      FootballLeaguePlayerStatisticsItem: {
        fields: {
          rank: {
            type: "int32",
            id: 1
          },
          player: {
            type: "FootballPlayer",
            id: 2
          },
          team: {
            type: "FootballTeam",
            id: 3
          },
          num: {
            type: "string",
            id: 4
          }
        }
      },
      FootballLeaguePlayerStatisticsRank: {
        fields: {
          name: {
            type: "string",
            id: 1
          },
          items: {
            rule: "repeated",
            type: "FootballLeaguePlayerStatisticsItem",
            id: 2
          }
        }
      },
      FootballLeaguePlayerStatistics: {
        fields: {
          list: {
            rule: "repeated",
            type: "FootballLeaguePlayerStatisticsRank",
            id: 1
          }
        }
      },
      FootballList: {
        fields: {
          match: {
            rule: "repeated",
            type: "FootballMatch",
            id: 1
          },
          league: {
            keyType: "uint64",
            type: "FootballLeague",
            id: 2
          },
          hotLeague: {
            rule: "repeated",
            type: "FootballLeague",
            id: 3
          },
          myLeague: {
            rule: "repeated",
            type: "FootballLeague",
            id: 4
          },
          serverTimestamp: {
            type: "uint32",
            id: 5
          },
          version: {
            type: "uint64",
            id: 6
          },
          asianLuckMatch: {
            keyType: "uint64",
            type: "AsianLuck",
            id: 7
          },
          threeWayLuckMatch: {
            keyType: "uint64",
            type: "ThreeWayLuck",
            id: 8
          },
          totalLuckMatch: {
            keyType: "uint64",
            type: "TotalLuck",
            id: 9
          },
          follow: {
            keyType: "uint64",
            type: "bool",
            id: 10
          }
        }
      },
      FootballFollowList: {
        fields: {
          match: {
            rule: "repeated",
            type: "FootballMatch",
            id: 1
          },
          league: {
            keyType: "uint64",
            type: "FootballLeague",
            id: 2
          }
        }
      },
      FootballMatchInfo: {
        fields: {
          match: {
            type: "FootballMatch",
            id: 1
          },
          league: {
            type: "FootballLeague",
            id: 2
          },
          isFollow: {
            type: "bool",
            id: 3
          },
          serverTimestamp: {
            type: "uint32",
            id: 4
          },
          shareUrl: {
            type: "string",
            id: 5
          }
        }
      },
      FootballMatchSummary: {
        oneofs: {
          _luck: {
            oneof: [
              "luck"
            ]
          },
          _chanceStats: {
            oneof: [
              "chanceStats"
            ]
          }
        },
        fields: {
          courtInfoList: {
            rule: "repeated",
            type: "CourtInfo",
            id: 1
          },
          luck: {
            type: "Luck",
            id: 2,
            options: {
              proto3_optional: true
            }
          },
          chanceStats: {
            type: "ChanceStats",
            id: 3,
            options: {
              proto3_optional: true
            }
          },
          keyList: {
            rule: "repeated",
            type: "EventKeyItem",
            id: 4
          }
        },
        nested: {
          Luck: {
            fields: {
              threeWay: {
                type: "ThreeWayLuck",
                id: 1
              },
              asina: {
                type: "AsianLuck",
                id: 2
              },
              total: {
                type: "TotalLuck",
                id: 3
              }
            }
          },
          ChanceStats: {
            fields: {
              goal: {
                type: "StatType",
                id: 1
              },
              card: {
                type: "StatType",
                id: 2
              }
            },
            nested: {
              StatVals: {
                fields: {
                  homeTeamValues: {
                    rule: "repeated",
                    type: "string",
                    id: 1
                  },
                  awayTeamValues: {
                    rule: "repeated",
                    type: "string",
                    id: 2
                  }
                }
              },
              StatRange: {
                fields: {
                  currentSeason: {
                    type: "StatVals",
                    id: 1
                  },
                  recentTen: {
                    type: "StatVals",
                    id: 2
                  },
                  recentTwenty: {
                    type: "StatVals",
                    id: 3
                  },
                  currentSeasonSameSide: {
                    type: "StatVals",
                    id: 4
                  },
                  recentTenSameSide: {
                    type: "StatVals",
                    id: 5
                  },
                  recentTwentySameSide: {
                    type: "StatVals",
                    id: 6
                  }
                }
              },
              StatType: {
                fields: {
                  first: {
                    type: "StatRange",
                    id: 1
                  },
                  again: {
                    type: "StatRange",
                    id: 2
                  }
                }
              }
            }
          },
          CourtInfo: {
            fields: {
              title: {
                type: "string",
                id: 1
              },
              content: {
                type: "string",
                id: 2
              }
            }
          },
          EventKeyItem: {
            oneofs: {
              _eventPlayer: {
                oneof: [
                  "eventPlayer"
                ]
              },
              _changePlayer: {
                oneof: [
                  "changePlayer"
                ]
              },
              _assistPlayer: {
                oneof: [
                  "assistPlayer"
                ]
              }
            },
            fields: {
              id: {
                type: "uint64",
                id: 1
              },
              happenTime: {
                type: "uint32",
                id: 2
              },
              eventType: {
                type: "uint32",
                id: 3
              },
              teamNum: {
                type: "uint32",
                id: 4
              },
              eventPlayer: {
                type: "FootballPlayer",
                id: 5,
                options: {
                  proto3_optional: true
                }
              },
              changePlayer: {
                type: "FootballPlayer",
                id: 6,
                options: {
                  proto3_optional: true
                }
              },
              score: {
                type: "string",
                id: 7
              },
              assistPlayer: {
                type: "FootballPlayer",
                id: 8,
                options: {
                  proto3_optional: true
                }
              },
              extraTime: {
                type: "uint32",
                id: 9
              }
            }
          }
        }
      },
      FootballMatchStats: {
        fields: {
          stats: {
            rule: "repeated",
            type: "Stats",
            id: 1
          }
        },
        nested: {
          Stats: {
            fields: {
              id: {
                type: "uint64",
                id: 1
              },
              eventName: {
                type: "string",
                id: 2
              },
              homeValue: {
                type: "string",
                id: 3
              },
              awayValue: {
                type: "string",
                id: 4
              },
              isSpecialMark: {
                type: "bool",
                id: 5
              }
            }
          }
        }
      },
      FootballMatchLineup: {
        fields: {
          lineupType: {
            type: "uint32",
            id: 1
          },
          formatHome: {
            type: "string",
            id: 2
          },
          formatAway: {
            type: "string",
            id: 3
          },
          match: {
            type: "FootballMatch",
            id: 4
          },
          startHome: {
            rule: "repeated",
            type: "Player",
            id: 5
          },
          startAway: {
            rule: "repeated",
            type: "Player",
            id: 6
          },
          backupHome: {
            rule: "repeated",
            type: "Player",
            id: 7
          },
          backupAway: {
            rule: "repeated",
            type: "Player",
            id: 8
          },
          subHome: {
            rule: "repeated",
            type: "PlayerSubstitution",
            id: 9
          },
          subAway: {
            rule: "repeated",
            type: "PlayerSubstitution",
            id: 10
          }
        },
        nested: {
          Player: {
            fields: {
              player: {
                type: "FootballPlayer",
                id: 1
              },
              mark: {
                type: "string",
                id: 2
              },
              isChanged: {
                type: "uint32",
                id: 3
              },
              changeTime: {
                type: "string",
                id: 4
              },
              event: {
                rule: "repeated",
                type: "uint32",
                id: 5
              }
            }
          },
          PlayerSubstitution: {
            oneofs: {
              _playerUp: {
                oneof: [
                  "playerUp"
                ]
              },
              _playerDown: {
                oneof: [
                  "playerDown"
                ]
              }
            },
            fields: {
              playerUp: {
                type: "Player",
                id: 1,
                options: {
                  proto3_optional: true
                }
              },
              playerDown: {
                type: "Player",
                id: 2,
                options: {
                  proto3_optional: true
                }
              }
            }
          }
        }
      },
      FootballMatchLineupPlayerDetails: {
        fields: {
          player: {
            type: "FootballPlayer",
            id: 1
          },
          changeTime: {
            type: "string",
            id: 2
          },
          mark: {
            type: "string",
            id: 3
          },
          goal: {
            type: "string",
            id: 4
          },
          point: {
            type: "string",
            id: 5
          },
          ownGoal: {
            type: "string",
            id: 6
          },
          assisting: {
            type: "string",
            id: 7
          },
          enterMinute: {
            type: "string",
            id: 8
          },
          yellowCard: {
            type: "string",
            id: 9
          },
          redCard: {
            type: "string",
            id: 10
          },
          shoot: {
            type: "string",
            id: 11
          },
          shotsTarget: {
            type: "string",
            id: 12
          },
          dangerShoot: {
            type: "string",
            id: 13
          },
          pass: {
            type: "string",
            id: 14
          },
          passSuccess: {
            type: "string",
            id: 15
          },
          keyPass: {
            type: "string",
            id: 16
          },
          longPass: {
            type: "string",
            id: 17
          },
          longPassPrecise: {
            type: "string",
            id: 18
          },
          crossing: {
            type: "string",
            id: 19
          },
          crossingPrecise: {
            type: "string",
            id: 20
          },
          formShotPass: {
            type: "string",
            id: 21
          },
          dropPass: {
            type: "string",
            id: 22
          },
          dropPassPrecise: {
            type: "string",
            id: 23
          },
          dribble: {
            type: "string",
            id: 24
          },
          dribbleSuccess: {
            type: "string",
            id: 25
          },
          offside: {
            type: "string",
            id: 26
          },
          intercept: {
            type: "string",
            id: 27
          },
          tackle: {
            type: "string",
            id: 28
          },
          cleared: {
            type: "string",
            id: 29
          },
          rescue: {
            type: "string",
            id: 30
          },
          foul: {
            type: "string",
            id: 31
          },
          beFouled: {
            type: "string",
            id: 32
          },
          hasData: {
            type: "bool",
            id: 33
          }
        }
      },
      FootballMatchEvent: {
        fields: {
          eventList: {
            rule: "repeated",
            type: "EventLiveItem",
            id: 1
          }
        },
        nested: {
          EventLiveItem: {
            oneofs: {
              _team: {
                oneof: [
                  "team"
                ]
              }
            },
            fields: {
              team: {
                type: "FootballTeam",
                id: 1,
                options: {
                  proto3_optional: true
                }
              },
              eventType: {
                type: "uint32",
                id: 2
              },
              matchState: {
                type: "string",
                id: 3
              },
              content: {
                type: "string",
                id: 4
              },
              score: {
                type: "string",
                id: 5
              }
            }
          }
        }
      },
      FootballMatchLuck: {
        fields: {
          asian: {
            rule: "repeated",
            type: "AsianLuck",
            id: 1
          },
          threeWay: {
            rule: "repeated",
            type: "ThreeWayLuck",
            id: 2
          },
          total: {
            rule: "repeated",
            type: "TotalLuck",
            id: 3
          }
        }
      },
      FootballMatchLuckLog: {
        fields: {
          companyId: {
            type: "string",
            id: 1
          },
          hasLive: {
            type: "uint32",
            id: 2
          },
          luckRecords: {
            rule: "repeated",
            type: "LuckRecord",
            id: 3
          }
        }
      },
      FootballMatchH2h: {
        fields: {
          recentTwentyH2h: {
            rule: "repeated",
            type: "FootballMatch",
            id: 1
          },
          recentTwentyHome: {
            rule: "repeated",
            type: "FootballMatch",
            id: 2
          },
          recentTwentyAway: {
            rule: "repeated",
            type: "FootballMatch",
            id: 3
          },
          league: {
            keyType: "uint64",
            type: "FootballLeague",
            id: 4
          },
          asianLuck: {
            keyType: "uint64",
            type: "AsianLuck",
            id: 5
          },
          totalLuck: {
            keyType: "uint64",
            type: "TotalLuck",
            id: 6
          },
          asianLuckHomeResult: {
            keyType: "uint64",
            type: "AsianLuck",
            id: 7
          },
          totalLuckHomeResult: {
            keyType: "uint64",
            type: "TotalLuck",
            id: 8
          },
          asianLuckAwayResult: {
            keyType: "uint64",
            type: "AsianLuck",
            id: 9
          },
          totalLuckAwayResult: {
            keyType: "uint64",
            type: "TotalLuck",
            id: 10
          },
          sameLuckHome: {
            rule: "repeated",
            type: "FootballMatch",
            id: 11
          },
          sameLuckAway: {
            rule: "repeated",
            type: "FootballMatch",
            id: 12
          },
          asianSameLuckHomeResult: {
            keyType: "uint64",
            type: "AsianLuck",
            id: 13
          },
          asianSameLuckAwayResult: {
            keyType: "uint64",
            type: "AsianLuck",
            id: 14
          },
          fixtureHome: {
            rule: "repeated",
            type: "FootballMatch",
            id: 15
          },
          fixtureAway: {
            rule: "repeated",
            type: "FootballMatch",
            id: 16
          }
        }
      },
      FootballMatchStanding: {
        fields: {
          standing: {
            type: "FootballLeagueStandings",
            id: 1
          },
          playing: {
            rule: "repeated",
            type: "FootballTeam",
            id: 2
          }
        }
      },
      FootballMatchPrediction: {
        oneofs: {
          _masterM: {
            oneof: [
              "masterM"
            ]
          },
          _pa: {
            oneof: [
              "pa"
            ]
          }
        },
        fields: {
          masterM: {
            type: "FootballPredictionMasterM",
            id: 1,
            options: {
              proto3_optional: true
            }
          },
          pa: {
            type: "FootballPredictionPA",
            id: 2,
            options: {
              proto3_optional: true
            }
          }
        }
      },
      FootballListUpdate: {
        fields: {
          addMatch: {
            rule: "repeated",
            type: "FootballMatch",
            id: 1
          },
          addLeague: {
            rule: "repeated",
            type: "FootballLeague",
            id: 2
          },
          removeMatch: {
            rule: "repeated",
            type: "uint64",
            id: 3
          },
          removeLeague: {
            rule: "repeated",
            type: "uint64",
            id: 4
          },
          updateMatch: {
            rule: "repeated",
            type: "FootballMatchUpdate",
            id: 5
          },
          version: {
            type: "uint64",
            id: 6
          }
        }
      },
      FootballListLuckUpdate: {
        fields: {
          asianLuckMatch: {
            keyType: "uint64",
            type: "AsianLuck",
            id: 1
          },
          threeWayLuckMatch: {
            keyType: "uint64",
            type: "ThreeWayLuck",
            id: 2
          },
          totalLuckMatch: {
            keyType: "uint64",
            type: "TotalLuck",
            id: 3
          },
          version: {
            type: "uint64",
            id: 4
          }
        }
      },
      FootballMatchDetailUpdate: {
        fields: {
          matchId: {
            type: "uint64",
            id: 1
          },
          updateMatch: {
            type: "FootballMatchUpdate",
            id: 2
          }
        }
      },
      FootballMatchDetailGoalUpdate: {
        fields: {
          matchId: {
            type: "uint64",
            id: 1
          },
          keyList: {
            rule: "repeated",
            type: "FootballMatchSummary.EventKeyItem",
            id: 2
          }
        }
      },
      FootballMatchDetailLuckUpdate: {
        oneofs: {
          _asian: {
            oneof: [
              "asian"
            ]
          },
          _threeWay: {
            oneof: [
              "threeWay"
            ]
          },
          _total: {
            oneof: [
              "total"
            ]
          }
        },
        fields: {
          matchId: {
            type: "uint64",
            id: 1
          },
          asian: {
            type: "AsianLuck",
            id: 2,
            options: {
              proto3_optional: true
            }
          },
          threeWay: {
            type: "ThreeWayLuck",
            id: 3,
            options: {
              proto3_optional: true
            }
          },
          total: {
            type: "TotalLuck",
            id: 4,
            options: {
              proto3_optional: true
            }
          }
        }
      },
      FootballMatchLuckUpdate: {
        fields: {
          matchId: {
            type: "uint64",
            id: 1
          },
          asian: {
            rule: "repeated",
            type: "AsianLuck",
            id: 2
          },
          threeWay: {
            rule: "repeated",
            type: "ThreeWayLuck",
            id: 3
          },
          total: {
            rule: "repeated",
            type: "TotalLuck",
            id: 4
          }
        }
      },
      FootballMatchStandingUpdate: {
        fields: {
          matchId: {
            type: "uint64",
            id: 1
          },
          updateData: {
            type: "FootballMatchStanding",
            id: 2
          }
        }
      },
      FootballMatchEventUpdate: {
        fields: {
          matchId: {
            type: "uint64",
            id: 1
          },
          updateData: {
            type: "FootballMatchEvent",
            id: 2
          }
        }
      },
      FootballMatchStatsUpdate: {
        fields: {
          matchId: {
            type: "uint64",
            id: 1
          },
          updateData: {
            type: "FootballMatchStats",
            id: 2
          }
        }
      },
      AiFootballList: {
        fields: {
          match: {
            rule: "repeated",
            type: "SimpleMatch",
            id: 1
          },
          serverTimestamp: {
            type: "uint32",
            id: 2
          }
        }
      },
      AiFootballMatchEvent: {
        fields: {
          event: {
            rule: "repeated",
            type: "AiFootballMatchEventItem",
            id: 1
          }
        }
      },
      AiFootballMatchEventItem: {
        oneofs: {
          _message: {
            oneof: [
              "message"
            ]
          },
          _data: {
            oneof: [
              "data"
            ]
          }
        },
        fields: {
          type: {
            type: "uint32",
            id: 1
          },
          message: {
            type: "string",
            id: 2,
            options: {
              proto3_optional: true
            }
          },
          data: {
            type: "google.protobuf.Any",
            id: 3,
            options: {
              proto3_optional: true
            }
          }
        }
      },
      AiFootballStat: {
        fields: {
          home: {
            type: "AiFootballTeamLive",
            id: 1
          },
          away: {
            type: "AiFootballTeamLive",
            id: 2
          }
        }
      },
      AiFootballTeamLive: {
        oneofs: {
          _yellowCard: {
            oneof: [
              "yellowCard"
            ]
          },
          _redCard: {
            oneof: [
              "redCard"
            ]
          },
          _corner: {
            oneof: [
              "corner"
            ]
          },
          _scoreHalf: {
            oneof: [
              "scoreHalf"
            ]
          },
          _scoreOt: {
            oneof: [
              "scoreOt"
            ]
          },
          _scorePen: {
            oneof: [
              "scorePen"
            ]
          },
          _ballPossession: {
            oneof: [
              "ballPossession"
            ]
          }
        },
        fields: {
          yellowCard: {
            type: "uint32",
            id: 1,
            options: {
              proto3_optional: true
            }
          },
          redCard: {
            type: "uint32",
            id: 2,
            options: {
              proto3_optional: true
            }
          },
          corner: {
            type: "uint32",
            id: 3,
            options: {
              proto3_optional: true
            }
          },
          scoreFull: {
            type: "uint32",
            id: 4
          },
          scoreHalf: {
            type: "uint32",
            id: 5,
            options: {
              proto3_optional: true
            }
          },
          scoreOt: {
            type: "uint32",
            id: 6,
            options: {
              proto3_optional: true
            }
          },
          scorePen: {
            type: "uint32",
            id: 7,
            options: {
              proto3_optional: true
            }
          },
          ballPossession: {
            type: "string",
            id: 8,
            options: {
              proto3_optional: true
            }
          }
        }
      },
      AiFootballMatchH2h: {
        fields: {
          standing: {
            type: "standingItem",
            id: 1
          },
          h2h: {
            type: "h2hItem",
            id: 2
          },
          h2hstat: {
            rule: "repeated",
            type: "h2hstatItem",
            id: 3
          }
        },
        nested: {
          standingItem: {
            fields: {
              home: {
                type: "h2hStanding",
                id: 1
              },
              away: {
                type: "h2hStanding",
                id: 2
              }
            }
          },
          h2hStanding: {
            fields: {
              rank: {
                type: "uint32",
                id: 1
              },
              pl: {
                type: "uint32",
                id: 2
              },
              gd: {
                type: "int32",
                id: 3
              },
              pts: {
                type: "uint32",
                id: 4
              }
            }
          },
          h2hItem: {
            fields: {
              win: {
                type: "uint32",
                id: 1
              },
              draw: {
                type: "uint32",
                id: 2
              },
              lose: {
                type: "uint32",
                id: 3
              }
            }
          },
          h2hstatItem: {
            fields: {
              key: {
                type: "string",
                id: 1
              },
              homeValue: {
                type: "string",
                id: 2
              },
              awayValue: {
                type: "string",
                id: 3
              }
            }
          }
        }
      },
      FootballMatchAiEventUpdate: {
        fields: {
          matchId: {
            type: "uint64",
            id: 1
          },
          event: {
            rule: "repeated",
            type: "AiFootballMatchEventItem",
            id: 2
          }
        }
      },
      FootballSearchItem: {
        fields: {
          type: {
            type: "int32",
            id: 1
          },
          id: {
            type: "int32",
            id: 2
          },
          name: {
            type: "string",
            id: 3
          },
          groupId: {
            type: "int32",
            id: 4
          },
          groupName: {
            type: "string",
            id: 5
          }
        }
      },
      FootballSearch: {
        fields: {
          result: {
            rule: "repeated",
            type: "FootballSearchItem",
            id: 1
          }
        }
      },
      FootballSearchRecord: {
        fields: {
          record: {
            rule: "repeated",
            type: "FootballSearchItem",
            id: 1
          },
          hot: {
            rule: "repeated",
            type: "FootballSearchItem",
            id: 2
          }
        }
      },
      SpecialFootballList: {
        fields: {
          match: {
            rule: "repeated",
            type: "FootballMatch",
            id: 1
          },
          league: {
            keyType: "uint64",
            type: "FootballLeague",
            id: 2
          },
          stage: {
            keyType: "int32",
            type: "FootballStage",
            id: 3
          },
          serverTimestamp: {
            type: "uint32",
            id: 4
          },
          version: {
            type: "uint64",
            id: 5
          }
        }
      },
      SpecialKnockoutList: {
        fields: {
          match: {
            rule: "repeated",
            type: "MatchItem",
            id: 1
          },
          stage: {
            keyType: "int32",
            type: "FootballStage",
            id: 2
          },
          teams: {
            keyType: "uint64",
            type: "FootballTeam",
            id: 3
          }
        },
        nested: {
          MatchItem: {
            oneofs: {
              _homeLive: {
                oneof: [
                  "homeLive"
                ]
              },
              _awayLive: {
                oneof: [
                  "awayLive"
                ]
              }
            },
            fields: {
              matchId: {
                type: "uint64",
                id: 1
              },
              startTime: {
                type: "uint64",
                id: 2
              },
              stageId: {
                type: "string",
                id: 3
              },
              homeTeamId: {
                type: "uint64",
                id: 4
              },
              awayTeamId: {
                type: "uint64",
                id: 5
              },
              homeLive: {
                type: "FootballTeamLive",
                id: 6,
                options: {
                  proto3_optional: true
                }
              },
              awayLive: {
                type: "FootballTeamLive",
                id: 7,
                options: {
                  proto3_optional: true
                }
              }
            }
          }
        }
      },
      SpecialTeamStat: {
        fields: {
          stat: {
            rule: "repeated",
            type: "Stat",
            id: 1
          }
        },
        nested: {
          Stat: {
            fields: {
              team: {
                type: "FootballTeam",
                id: 1
              },
              total: {
                type: "uint64",
                id: 2
              },
              win: {
                type: "uint64",
                id: 3
              },
              draw: {
                type: "uint64",
                id: 4
              },
              loss: {
                type: "uint64",
                id: 5
              },
              winLuck: {
                type: "uint32",
                id: 6
              },
              drawLuck: {
                type: "uint32",
                id: 7
              },
              lossLuck: {
                type: "uint32",
                id: 8
              },
              winLuckRate: {
                type: "string",
                id: 9
              },
              goal: {
                type: "uint64",
                id: 10
              },
              point: {
                type: "uint64",
                id: 11
              },
              yellowCard: {
                type: "uint64",
                id: 12
              },
              redCard: {
                type: "uint64",
                id: 13
              }
            }
          }
        }
      },
      MatchPredictionList: {
        fields: {
          list: {
            keyType: "uint64",
            type: "FootballMatchPrediction",
            id: 1
          }
        }
      },
      PredictionDateList: {
        fields: {
          list: {
            rule: "repeated",
            type: "string",
            id: 1
          }
        }
      },
      NewsProfile: {
        oneofs: {
          _source: {
            oneof: [
              "source"
            ]
          },
          _author: {
            oneof: [
              "author"
            ]
          }
        },
        fields: {
          id: {
            type: "uint32",
            id: 1
          },
          title: {
            type: "string",
            id: 2
          },
          source: {
            type: "string",
            id: 3,
            options: {
              proto3_optional: true
            }
          },
          thumbnail: {
            type: "string",
            id: 4
          },
          createTime: {
            type: "uint64",
            id: 5
          },
          author: {
            type: "NewsAuthor",
            id: 6,
            options: {
              proto3_optional: true
            }
          }
        }
      },
      News: {
        oneofs: {
          _source: {
            oneof: [
              "source"
            ]
          },
          _author: {
            oneof: [
              "author"
            ]
          }
        },
        fields: {
          id: {
            type: "uint32",
            id: 1
          },
          title: {
            type: "string",
            id: 2
          },
          keyword: {
            type: "string",
            id: 3
          },
          description: {
            type: "string",
            id: 4
          },
          source: {
            type: "string",
            id: 5,
            options: {
              proto3_optional: true
            }
          },
          thumbnail: {
            type: "string",
            id: 6
          },
          createTime: {
            type: "uint64",
            id: 7
          },
          content: {
            type: "string",
            id: 8
          },
          author: {
            type: "NewsAuthor",
            id: 9,
            options: {
              proto3_optional: true
            }
          },
          category: {
            type: "NewsCategory",
            id: 10
          },
          shareUrl: {
            type: "string",
            id: 11
          }
        }
      },
      NewsAuthor: {
        oneofs: {
          _avatar: {
            oneof: [
              "avatar"
            ]
          },
          _profile: {
            oneof: [
              "profile"
            ]
          }
        },
        fields: {
          id: {
            type: "uint32",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          },
          avatar: {
            type: "string",
            id: 3,
            options: {
              proto3_optional: true
            }
          },
          profile: {
            type: "string",
            id: 4,
            options: {
              proto3_optional: true
            }
          }
        }
      },
      NewsCategory: {
        fields: {
          id: {
            type: "uint32",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          }
        }
      },
      PredictionAuthor: {
        oneofs: {
          _profile: {
            oneof: [
              "profile"
            ]
          }
        },
        fields: {
          id: {
            type: "uint32",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          },
          avatar: {
            type: "string",
            id: 3
          },
          profile: {
            type: "string",
            id: 4,
            options: {
              proto3_optional: true
            }
          }
        }
      },
      Prediction: {
        oneofs: {
          _prediction: {
            oneof: [
              "prediction"
            ]
          },
          _author: {
            oneof: [
              "author"
            ]
          },
          _createTime: {
            oneof: [
              "createTime"
            ]
          }
        },
        fields: {
          match: {
            type: "SimpleMatch",
            id: 1
          },
          prediction: {
            type: "google.protobuf.Any",
            id: 2,
            options: {
              proto3_optional: true
            }
          },
          author: {
            type: "PredictionAuthor",
            id: 3,
            options: {
              proto3_optional: true
            }
          },
          createTime: {
            type: "uint64",
            id: 4,
            options: {
              proto3_optional: true
            }
          }
        }
      },
      FootballPredictionMasterM: {
        fields: {
          confidence: {
            type: "int32",
            id: 1
          },
          side: {
            type: "string",
            id: 2
          },
          content: {
            type: "string",
            id: 3
          },
          author: {
            type: "PredictionAuthor",
            id: 4
          },
          createTime: {
            type: "uint64",
            id: 5
          },
          lastHome: {
            type: "string",
            id: 6
          },
          lastAway: {
            type: "string",
            id: 7
          }
        }
      },
      FootballPredictionPA: {
        fields: {
          score: {
            type: "string",
            id: 1
          },
          content: {
            type: "string",
            id: 2
          },
          author: {
            type: "PredictionAuthor",
            id: 3
          },
          createTime: {
            type: "uint64",
            id: 4
          }
        }
      },
      FootballPlayerInfo: {
        fields: {
          baseInfo: {
            type: "BaseInfo",
            id: 1
          },
          transfer: {
            type: "Transfer",
            id: 2
          }
        },
        nested: {
          BaseInfo: {
            oneofs: {
              _jerseyNumber: {
                oneof: [
                  "jerseyNumber"
                ]
              }
            },
            fields: {
              id: {
                type: "uint64",
                id: 1
              },
              name: {
                type: "string",
                id: 2
              },
              position: {
                type: "PlayerPosition",
                id: 3
              },
              jerseyNumber: {
                type: "uint32",
                id: 4,
                options: {
                  proto3_optional: true
                }
              },
              country: {
                rule: "repeated",
                type: "Country",
                id: 5
              },
              marketvalue: {
                type: "string",
                id: 6
              },
              birthday: {
                type: "string",
                id: 7
              },
              height: {
                type: "string",
                id: 8
              },
              weight: {
                type: "string",
                id: 9
              },
              preferredFoot: {
                type: "uint32",
                id: 10
              },
              honor: {
                type: "string",
                id: 11
              },
              introduction: {
                type: "string",
                id: 12
              }
            }
          },
          Transfer: {
            fields: {}
          }
        }
      },
      FootballPlayerDataStatistics: {
        fields: {
          dataStatisticsItem: {
            rule: "repeated",
            type: "DataStatisticsItem",
            id: 1
          }
        },
        nested: {
          DataStatisticsItem: {
            fields: {
              baseInfo: {
                type: "BaseInfo",
                id: 1
              },
              attack: {
                type: "Attack",
                id: 2
              },
              tissue: {
                type: "Tissue",
                id: 3
              },
              defend: {
                type: "Defend",
                id: 4
              },
              confront: {
                type: "Confront",
                id: 5
              },
              keepGoal: {
                type: "KeepGoal",
                id: 6
              }
            }
          },
          BaseInfo: {
            fields: {
              date: {
                type: "string",
                id: 1
              },
              league: {
                type: "string",
                id: 2
              },
              team: {
                type: "string",
                id: 3
              },
              infos: {
                type: "InfoInfos",
                id: 4
              }
            },
            nested: {
              InfoInfos: {
                oneofs: {
                  _goalsAndwonPenalty: {
                    oneof: [
                      "goalsAndwonPenalty"
                    ]
                  },
                  _goalAssist: {
                    oneof: [
                      "goalAssist"
                    ]
                  },
                  _cleanSheets: {
                    oneof: [
                      "cleanSheets"
                    ]
                  },
                  _goalsConceded: {
                    oneof: [
                      "goalsConceded"
                    ]
                  }
                },
                fields: {
                  matchesAndstarted: {
                    type: "string",
                    id: 1
                  },
                  goalsAndwonPenalty: {
                    type: "string",
                    id: 2,
                    options: {
                      proto3_optional: true
                    }
                  },
                  goalAssist: {
                    type: "string",
                    id: 3,
                    options: {
                      proto3_optional: true
                    }
                  },
                  cleanSheets: {
                    type: "string",
                    id: 4,
                    options: {
                      proto3_optional: true
                    }
                  },
                  goalsConceded: {
                    type: "string",
                    id: 5,
                    options: {
                      proto3_optional: true
                    }
                  },
                  rating: {
                    type: "string",
                    id: 6
                  },
                  minutesPlayed: {
                    type: "string",
                    id: 7
                  },
                  yellow: {
                    type: "string",
                    id: 8
                  },
                  red: {
                    type: "string",
                    id: 9
                  }
                }
              }
            }
          },
          Attack: {
            fields: {
              goalsAndwonPenalty: {
                type: "string",
                id: 1
              },
              goalsFrequency: {
                type: "string",
                id: 2
              },
              totalShots: {
                type: "string",
                id: 3
              },
              onTargetScoringAttempt: {
                type: "string",
                id: 4
              },
              onTargetScoringAttemptRate: {
                type: "string",
                id: 5
              },
              fromInsideTheBox: {
                type: "string",
                id: 6
              },
              fromOutsideTheBox: {
                type: "string",
                id: 7
              },
              freeKickGoals: {
                type: "string",
                id: 8
              },
              dribblesTotal: {
                type: "string",
                id: 9
              },
              successfulDribbles: {
                type: "string",
                id: 10
              },
              successfulDribblesRate: {
                type: "string",
                id: 11
              },
              bigChancesCreated: {
                type: "string",
                id: 12
              }
            }
          },
          Tissue: {
            fields: {
              goalAssist: {
                type: "string",
                id: 1
              },
              totalPasses: {
                type: "string",
                id: 2
              },
              accuratePasses: {
                type: "string",
                id: 3
              },
              accuratePassesRate: {
                type: "string",
                id: 4
              },
              keyPasses: {
                type: "string",
                id: 5
              },
              totalLongBalls: {
                type: "string",
                id: 6
              },
              accurateLongBalls: {
                type: "string",
                id: 7
              },
              accurateLongBallsRate: {
                type: "string",
                id: 8
              },
              totalCrosses: {
                type: "string",
                id: 9
              },
              accurateCrosses: {
                type: "string",
                id: 10
              },
              accurateCrossesRate: {
                type: "string",
                id: 11
              }
            }
          },
          Defend: {
            fields: {
              interceptionWonPerGame: {
                type: "string",
                id: 1
              },
              totalTacklePerGame: {
                type: "string",
                id: 2
              },
              clearancePerGame: {
                type: "string",
                id: 3
              },
              errorLeadToAShot: {
                type: "string",
                id: 4
              },
              errorLeadToGoal: {
                type: "string",
                id: 5
              },
              ownGoals: {
                type: "string",
                id: 6
              }
            }
          },
          Confront: {
            fields: {
              yellow: {
                type: "string",
                id: 1
              },
              red: {
                type: "string",
                id: 2
              },
              totalDuel: {
                type: "string",
                id: 3
              },
              wonDuel: {
                type: "string",
                id: 4
              },
              wonDuelRate: {
                type: "string",
                id: 5
              },
              totalAerial: {
                type: "string",
                id: 6
              },
              wonAerial: {
                type: "string",
                id: 7
              },
              wonAerialRate: {
                type: "string",
                id: 8
              },
              totalDuels: {
                type: "string",
                id: 9
              },
              totalDuelsWon: {
                type: "string",
                id: 10
              },
              totalDuelsWonRate: {
                type: "string",
                id: 11
              }
            }
          },
          KeepGoal: {
            fields: {
              cleanSheets: {
                type: "string",
                id: 1
              },
              goalsConceded: {
                type: "string",
                id: 2
              },
              saves: {
                type: "string",
                id: 3
              },
              penaltiesSaved: {
                type: "string",
                id: 4
              },
              goodHighClaim: {
                type: "string",
                id: 5
              },
              totalKeeperSweeper: {
                type: "string",
                id: 6
              },
              accurateKeeperSweeper: {
                type: "string",
                id: 7
              }
            }
          }
        }
      },
      FootballPlayerLastTwentyMatches: {
        fields: {
          stat: {
            type: "LastTwentyMatchesStat",
            id: 1
          },
          matches: {
            rule: "repeated",
            type: "LastTwentyMatches",
            id: 2
          }
        },
        nested: {
          LastTwentyMatchesStat: {
            fields: {
              total: {
                type: "uint64",
                id: 1
              },
              goals: {
                type: "uint64",
                id: 2
              },
              penaltys: {
                type: "uint64",
                id: 3
              },
              assists: {
                type: "uint64",
                id: 4
              },
              yellowCards: {
                type: "uint64",
                id: 5
              },
              redCards: {
                type: "uint64",
                id: 6
              }
            }
          },
          LastTwentyMatches: {
            fields: {
              matchId: {
                type: "uint64",
                id: 1
              },
              startTime: {
                type: "uint64",
                id: 2
              },
              homeTeam: {
                type: "FootballTeam",
                id: 3
              },
              awayTeam: {
                type: "FootballTeam",
                id: 4
              },
              homeScore: {
                type: "uint32",
                id: 5
              },
              awayScore: {
                type: "uint32",
                id: 6
              },
              result: {
                type: "uint32",
                id: 7
              },
              goal: {
                type: "uint64",
                id: 8
              },
              penalty: {
                type: "uint64",
                id: 9
              },
              assist: {
                type: "uint64",
                id: 10
              },
              yellowCard: {
                type: "uint64",
                id: 11
              },
              redCard: {
                type: "uint64",
                id: 12
              },
              isHome: {
                type: "uint64",
                id: 13
              }
            }
          }
        }
      },
      FootballCoach: {
        fields: {
          baseInfo: {
            type: "BaseInfo",
            id: 1
          }
        },
        nested: {
          BaseInfo: {
            fields: {
              id: {
                type: "uint64",
                id: 1
              },
              name: {
                type: "string",
                id: 2
              },
              country: {
                rule: "repeated",
                type: "Country",
                id: 3
              },
              birthday: {
                type: "string",
                id: 4
              },
              current: {
                type: "string",
                id: 5
              },
              predecessor: {
                type: "string",
                id: 6
              },
              before: {
                type: "string",
                id: 7
              },
              honor: {
                type: "string",
                id: 8
              },
              introduction: {
                type: "string",
                id: 9
              }
            }
          }
        }
      },
      FootballTeamsOfLeague: {
        fields: {
          leagueInfo: {
            type: "FootballLeague",
            id: 1
          },
          teamList: {
            rule: "repeated",
            type: "FootballTeam",
            id: 2
          }
        }
      },
      FootballTeamInfo: {
        fields: {
          team: {
            type: "FootballTeam",
            id: 1
          },
          establishYear: {
            type: "string",
            id: 2
          },
          city: {
            type: "string",
            id: 3
          },
          stadium: {
            type: "string",
            id: 4
          },
          stadiumCapacity: {
            type: "string",
            id: 5
          },
          address: {
            type: "string",
            id: 6
          },
          price: {
            type: "string",
            id: 7
          },
          honor: {
            type: "string",
            id: 8
          },
          introduction: {
            type: "string",
            id: 9
          },
          website: {
            type: "string",
            id: 10
          },
          recordStats: {
            rule: "repeated",
            type: "uint32",
            id: 11
          }
        }
      },
      FootballTeamDataStats: {
        fields: {
          goalStats: {
            type: "TotalGoalStats",
            id: 1
          },
          matchGoalStatsAll: {
            type: "MatchGoalStats",
            id: 2
          },
          matchGoalStatsHome: {
            type: "MatchGoalStats",
            id: 3
          },
          matchGoalStatsNeutral: {
            type: "MatchGoalStats",
            id: 4
          },
          matchGoalStatsAway: {
            type: "MatchGoalStats",
            id: 5
          }
        },
        nested: {
          TotalGoalStats: {
            fields: {
              total01: {
                type: "uint32",
                id: 1
              },
              total23: {
                type: "uint32",
                id: 2
              },
              total46: {
                type: "uint32",
                id: 3
              },
              total7More: {
                type: "uint32",
                id: 4
              },
              totalOdd: {
                type: "uint32",
                id: 5
              },
              totalEven: {
                type: "uint32",
                id: 6
              }
            }
          },
          MatchGoalStats: {
            fields: {
              winStats: {
                type: "WinStats",
                id: 1
              },
              gameStats: {
                type: "GameStats",
                id: 2
              },
              luckStats: {
                type: "LuckStats",
                id: 3
              }
            },
            nested: {
              WinStats: {
                fields: {
                  total2More: {
                    type: "uint32",
                    id: 1
                  },
                  total1More: {
                    type: "uint32",
                    id: 2
                  },
                  totalDraw: {
                    type: "uint32",
                    id: 3
                  },
                  totalLoss1More: {
                    type: "uint32",
                    id: 4
                  },
                  totalLoss2More: {
                    type: "uint32",
                    id: 5
                  },
                  total2MoreRate: {
                    type: "string",
                    id: 6
                  },
                  total1MoreRate: {
                    type: "string",
                    id: 7
                  },
                  totalDrawRate: {
                    type: "string",
                    id: 8
                  },
                  totalLoss1MoreRate: {
                    type: "string",
                    id: 9
                  },
                  totalLoss2MoreRate: {
                    type: "string",
                    id: 10
                  }
                }
              },
              GameStats: {
                fields: {
                  total0: {
                    type: "uint32",
                    id: 1
                  },
                  total1: {
                    type: "uint32",
                    id: 2
                  },
                  total2: {
                    type: "uint32",
                    id: 3
                  },
                  total3More: {
                    type: "uint32",
                    id: 4
                  },
                  total0Rate: {
                    type: "string",
                    id: 5
                  },
                  total1Rate: {
                    type: "string",
                    id: 6
                  },
                  total2Rate: {
                    type: "string",
                    id: 7
                  },
                  total3MoreRate: {
                    type: "string",
                    id: 8
                  }
                }
              },
              LuckStats: {
                fields: {
                  homeWin: {
                    type: "uint32",
                    id: 1
                  },
                  homeDraw: {
                    type: "uint32",
                    id: 2
                  },
                  homeLoss: {
                    type: "uint32",
                    id: 3
                  },
                  awayWin: {
                    type: "uint32",
                    id: 4
                  },
                  awayDraw: {
                    type: "uint32",
                    id: 5
                  },
                  awayLoss: {
                    type: "uint32",
                    id: 6
                  },
                  drawWin: {
                    type: "uint32",
                    id: 7
                  },
                  drawDraw: {
                    type: "uint32",
                    id: 8
                  },
                  drawLoss: {
                    type: "uint32",
                    id: 9
                  },
                  homeWinRate: {
                    type: "string",
                    id: 10
                  },
                  homeDrawRate: {
                    type: "string",
                    id: 11
                  },
                  homeLossRate: {
                    type: "string",
                    id: 12
                  },
                  awayWinRate: {
                    type: "string",
                    id: 13
                  },
                  awayDrawRate: {
                    type: "string",
                    id: 14
                  },
                  awayLossRate: {
                    type: "string",
                    id: 15
                  },
                  drawWinRate: {
                    type: "string",
                    id: 16
                  },
                  drawDrawRate: {
                    type: "string",
                    id: 17
                  },
                  drawLossRate: {
                    type: "string",
                    id: 18
                  }
                }
              }
            }
          }
        }
      },
      FootballTeamPlayer: {
        fields: {
          playerGroup: {
            rule: "repeated",
            type: "PlayerGroup",
            id: 1
          }
        },
        nested: {
          PlayerGroup: {
            fields: {
              positionType: {
                type: "uint32",
                id: 1
              },
              positionName: {
                type: "string",
                id: 2
              },
              playerList: {
                rule: "repeated",
                type: "FootballPlayer",
                id: 3
              }
            }
          }
        }
      },
      FootballTeamFixture: {
        fields: {
          match: {
            rule: "repeated",
            type: "FixtureGroup",
            id: 1
          },
          league: {
            keyType: "uint32",
            type: "FootballLeague",
            id: 2
          }
        },
        nested: {
          FixtureGroup: {
            fields: {
              date: {
                type: "string",
                id: 1
              },
              list: {
                rule: "repeated",
                type: "FootballMatch",
                id: 2
              }
            }
          }
        }
      },
      FootballTeamResult: {
        fields: {
          match: {
            rule: "repeated",
            type: "ResultGroup",
            id: 1
          },
          league: {
            keyType: "uint32",
            type: "FootballLeague",
            id: 2
          },
          asianLuck: {
            keyType: "uint32",
            type: "AsianLuck",
            id: 3
          },
          totalLuck: {
            keyType: "uint32",
            type: "TotalLuck",
            id: 4
          },
          statsAll: {
            type: "ResultStats",
            id: 6
          },
          statsHome: {
            type: "ResultStats",
            id: 7
          },
          statsAway: {
            type: "ResultStats",
            id: 8
          },
          statsNeutral: {
            type: "ResultStats",
            id: 9
          }
        },
        nested: {
          ResultGroup: {
            fields: {
              date: {
                type: "string",
                id: 1
              },
              list: {
                rule: "repeated",
                type: "FootballMatch",
                id: 2
              }
            }
          },
          ResultStats: {
            oneofs: {
              _winLuck: {
                oneof: [
                  "winLuck"
                ]
              },
              _winLuckRate: {
                oneof: [
                  "winLuckRate"
                ]
              },
              _drawLuck: {
                oneof: [
                  "drawLuck"
                ]
              },
              _drawLuckRate: {
                oneof: [
                  "drawLuckRate"
                ]
              },
              _lossLuck: {
                oneof: [
                  "lossLuck"
                ]
              },
              _lossLuckRate: {
                oneof: [
                  "lossLuckRate"
                ]
              },
              _over: {
                oneof: [
                  "over"
                ]
              },
              _under: {
                oneof: [
                  "under"
                ]
              },
              _odd: {
                oneof: [
                  "odd"
                ]
              },
              _even: {
                oneof: [
                  "even"
                ]
              },
              _halfOver: {
                oneof: [
                  "halfOver"
                ]
              },
              _halfUnder: {
                oneof: [
                  "halfUnder"
                ]
              }
            },
            fields: {
              win: {
                type: "uint32",
                id: 1
              },
              winRate: {
                type: "string",
                id: 2
              },
              draw: {
                type: "uint32",
                id: 3
              },
              drawRate: {
                type: "string",
                id: 4
              },
              loss: {
                type: "uint32",
                id: 5
              },
              lossRate: {
                type: "string",
                id: 6
              },
              winLuck: {
                type: "uint32",
                id: 7,
                options: {
                  proto3_optional: true
                }
              },
              winLuckRate: {
                type: "string",
                id: 8,
                options: {
                  proto3_optional: true
                }
              },
              drawLuck: {
                type: "uint32",
                id: 9,
                options: {
                  proto3_optional: true
                }
              },
              drawLuckRate: {
                type: "string",
                id: 10,
                options: {
                  proto3_optional: true
                }
              },
              lossLuck: {
                type: "uint32",
                id: 11,
                options: {
                  proto3_optional: true
                }
              },
              lossLuckRate: {
                type: "string",
                id: 12,
                options: {
                  proto3_optional: true
                }
              },
              over: {
                type: "uint32",
                id: 13,
                options: {
                  proto3_optional: true
                }
              },
              under: {
                type: "uint32",
                id: 14,
                options: {
                  proto3_optional: true
                }
              },
              odd: {
                type: "uint32",
                id: 15,
                options: {
                  proto3_optional: true
                }
              },
              even: {
                type: "uint32",
                id: 16,
                options: {
                  proto3_optional: true
                }
              },
              halfOver: {
                type: "uint32",
                id: 17,
                options: {
                  proto3_optional: true
                }
              },
              halfUnder: {
                type: "uint32",
                id: 18,
                options: {
                  proto3_optional: true
                }
              }
            }
          }
        }
      },
      HelpIndex: {
        fields: {
          helpItem: {
            rule: "repeated",
            type: "HelpItem",
            id: 1
          }
        },
        nested: {
          HelpItem: {
            fields: {
              name: {
                type: "string",
                id: 1
              },
              type: {
                type: "uint32",
                id: 2
              },
              title: {
                rule: "repeated",
                type: "TitleItem",
                id: 3
              }
            }
          },
          TitleItem: {
            fields: {
              id: {
                type: "uint32",
                id: 1
              },
              title: {
                type: "string",
                id: 2
              }
            }
          }
        }
      },
      HelpInfo: {
        fields: {
          helpItem: {
            rule: "repeated",
            type: "HelpItem",
            id: 1
          }
        },
        nested: {
          HelpItem: {
            fields: {
              id: {
                type: "uint32",
                id: 1
              },
              title: {
                type: "string",
                id: 2
              },
              content: {
                type: "string",
                id: 3
              }
            }
          }
        }
      },
      CategoryList: {
        fields: {
          categoryList: {
            rule: "repeated",
            type: "NewsCategory",
            id: 1
          }
        }
      },
      NewsList: {
        fields: {
          topList: {
            rule: "repeated",
            type: "NewsProfile",
            id: 1
          },
          newsList: {
            rule: "repeated",
            type: "NewsProfile",
            id: 2
          },
          pageInfo: {
            type: "ListPageInfo",
            id: 3
          }
        }
      },
      NewsListLast: {
        fields: {
          newsList: {
            rule: "repeated",
            type: "NewsProfile",
            id: 1
          }
        }
      },
      PredictionList: {
        fields: {
          predictionList: {
            rule: "repeated",
            type: "Prediction",
            id: 1
          },
          league: {
            keyType: "uint32",
            type: "FootballLeague",
            id: 2
          },
          pageInfo: {
            type: "ListPageInfo",
            id: 3
          }
        }
      },
      Setting: {
        oneofs: {
          _footballLeagueLogo: {
            oneof: [
              "footballLeagueLogo"
            ]
          },
          _footballLeagueCountryLogo: {
            oneof: [
              "footballLeagueCountryLogo"
            ]
          },
          _footballTeamLogo: {
            oneof: [
              "footballTeamLogo"
            ]
          },
          _footballPlayerLogo: {
            oneof: [
              "footballPlayerLogo"
            ]
          },
          _footballCountryLogo: {
            oneof: [
              "footballCountryLogo"
            ]
          }
        },
        fields: {
          footballLeagueLogo: {
            type: "string",
            id: 1,
            options: {
              proto3_optional: true
            }
          },
          footballLeagueCountryLogo: {
            type: "string",
            id: 2,
            options: {
              proto3_optional: true
            }
          },
          footballTeamLogo: {
            type: "string",
            id: 3,
            options: {
              proto3_optional: true
            }
          },
          footballPlayerLogo: {
            type: "string",
            id: 4,
            options: {
              proto3_optional: true
            }
          },
          footballCountryLogo: {
            type: "string",
            id: 5,
            options: {
              proto3_optional: true
            }
          }
        }
      },
      Seo: {
        oneofs: {
          _title: {
            oneof: [
              "title"
            ]
          },
          _keyword: {
            oneof: [
              "keyword"
            ]
          },
          _description: {
            oneof: [
              "description"
            ]
          }
        },
        fields: {
          title: {
            type: "string",
            id: 1,
            options: {
              proto3_optional: true
            }
          },
          keyword: {
            type: "string",
            id: 2,
            options: {
              proto3_optional: true
            }
          },
          description: {
            type: "string",
            id: 3,
            options: {
              proto3_optional: true
            }
          }
        }
      },
      TransferLeague: {
        fields: {
          league: {
            type: "FootballLeague",
            id: 1
          },
          teamList: {
            rule: "repeated",
            type: "FootballTeam",
            id: 2
          }
        }
      },
      TransferItem: {
        fields: {
          player: {
            type: "FootballPlayer",
            id: 1
          },
          teamOut: {
            type: "FootballTeam",
            id: 2
          },
          teamIn: {
            type: "FootballTeam",
            id: 3
          },
          tranTime: {
            type: "uint32",
            id: 4
          },
          reason: {
            type: "string",
            id: 5
          },
          fee: {
            type: "string",
            id: 6
          }
        }
      },
      TransferList: {
        fields: {
          position: {
            rule: "repeated",
            type: "PlayerPosition",
            id: 1
          },
          league: {
            rule: "repeated",
            type: "TransferLeague",
            id: 2
          },
          items: {
            rule: "repeated",
            type: "TransferItem",
            id: 3
          },
          next: {
            type: "bool",
            id: 4
          }
        }
      },
      UserInfo: {
        fields: {
          info: {
            type: "UserInfoItem",
            id: 1
          }
        }
      },
      UserSettingInfo: {
        fields: {
          theme: {
            type: "uint32",
            id: 1
          },
          match: {
            type: "matchSetting",
            id: 2
          },
          lan: {
            type: "uint32",
            id: 3
          },
          screenSleep: {
            type: "bool",
            id: 4
          }
        },
        nested: {
          matchSetting: {
            fields: {
              messgePush: {
                type: "bool",
                id: 1
              },
              matchState: {
                type: "bool",
                id: 2
              },
              score: {
                type: "bool",
                id: 3
              },
              red: {
                type: "bool",
                id: 4
              }
            }
          }
        }
      },
      UserInfoItem: {
        oneofs: {
          _userInfoOAuth: {
            oneof: [
              "userInfoOAuth"
            ]
          }
        },
        fields: {
          uid: {
            type: "uint32",
            id: 1
          },
          nickname: {
            type: "string",
            id: 2
          },
          avatar: {
            type: "string",
            id: 3
          },
          token: {
            type: "string",
            id: 4
          },
          email: {
            type: "string",
            id: 5
          },
          expiresDate: {
            type: "uint32",
            id: 6
          },
          userInfoOAuth: {
            type: "UserInfoOAuthItem",
            id: 7,
            options: {
              proto3_optional: true
            }
          }
        }
      },
      UserInfoOAuthItem: {
        oneofs: {
          _googleToken: {
            oneof: [
              "googleToken"
            ]
          },
          _facebookToken: {
            oneof: [
              "facebookToken"
            ]
          },
          _appleToken: {
            oneof: [
              "appleToken"
            ]
          }
        },
        fields: {
          googleToken: {
            type: "string",
            id: 1,
            options: {
              proto3_optional: true
            }
          },
          facebookToken: {
            type: "string",
            id: 2,
            options: {
              proto3_optional: true
            }
          },
          appleToken: {
            type: "string",
            id: 3,
            options: {
              proto3_optional: true
            }
          }
        }
      },
      WebAd: {
        fields: {
          webAds: {
            rule: "repeated",
            type: "WebAdItem",
            id: 1
          }
        },
        nested: {
          WebAdItem: {
            oneofs: {
              _title: {
                oneof: [
                  "title"
                ]
              },
              _img: {
                oneof: [
                  "img"
                ]
              },
              _url: {
                oneof: [
                  "url"
                ]
              },
              _imgMobile: {
                oneof: [
                  "imgMobile"
                ]
              }
            },
            fields: {
              id: {
                type: "int32",
                id: 1
              },
              siteId: {
                type: "int32",
                id: 2
              },
              title: {
                type: "string",
                id: 3,
                options: {
                  proto3_optional: true
                }
              },
              img: {
                type: "string",
                id: 4,
                options: {
                  proto3_optional: true
                }
              },
              url: {
                type: "string",
                id: 5,
                options: {
                  proto3_optional: true
                }
              },
              flag: {
                type: "bool",
                id: 6
              },
              imgMobile: {
                type: "string",
                id: 7,
                options: {
                  proto3_optional: true
                }
              }
            }
          }
        }
      }
    }
  },
  google: {
    nested: {
      protobuf: {
        nested: {
          Any: {
            fields: {
              type_url: {
                type: "string",
                id: 1
              },
              value: {
                type: "bytes",
                id: 2
              }
            }
          }
        }
      }
    }
  }
});

module.exports = $root;



//////////////////
// WEBPACK FOOTER
// ./static/proto/proto.js
// module id = HYW6
// module chunks = 0